import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-center fill-height" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary text-h5 font-weight-bold" }, "Logging you in..", -1)
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_EmailPrompt = _resolveComponent("EmailPrompt")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_stepper_window_item = _resolveComponent("v-stepper-window-item")!
  const _component_PasswordPrompt = _resolveComponent("PasswordPrompt")!
  const _component_ResendPrompt = _resolveComponent("ResendPrompt")!
  const _component_v_stepper_window = _resolveComponent("v-stepper-window")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fill-height overflow-x-hidden", _ctx.smAndDown ? 'background-mob' : 'background'])
  }, [
    _createVNode(_component_v_row, { style: {"height":"calc(100% - 48px)"} }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "fill-height pa-4",
              justify: "center",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "auto" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "background-border",
                      flat: "",
                      height: "500",
                      color: "background"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, { class: "d-flex justify-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_img, {
                              src: _ctx.logoSrc,
                              "max-width": "300",
                              class: "mt-6"
                            }, {
                              placeholder: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, [
                                  _createVNode(_component_v_progress_circular, {
                                    color: "grey-lighten-4",
                                    indeterminate: ""
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["src"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_stepper, {
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.activeStep = $event)),
                          "model-value": _ctx.activeStep,
                          flat: "",
                          class: "fill-height",
                          id: "login-stepper",
                          onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.error = '')),
                          width: "380"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_stepper_window, { "model-value": _ctx.activeStep }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_stepper_window_item, {
                                  value: _ctx.LoginSteps.EmailPrompt,
                                  class: "fill-height",
                                  "selected-class": "px-3"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      class: "fill-height",
                                      justify: "center",
                                      align: "center",
                                      "no-gutters": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "fill-height"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_EmailPrompt, {
                                              onCheckEmail: _cache[0] || (_cache[0] = ($event: any) => {_ctx.username = $event; _ctx.checkUser();}),
                                              loading: _ctx.loading,
                                              error: _ctx.error,
                                              onClearError: _cache[1] || (_cache[1] = ($event: any) => (_ctx.error = '')),
                                              "query-username": _ctx.username
                                            }, null, 8, ["loading", "error", "query-username"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"]),
                                _createVNode(_component_v_stepper_window_item, {
                                  value: _ctx.LoginSteps.PasswordPrompt,
                                  class: "fill-height",
                                  "selected-class": "px-3"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      class: "fill-height",
                                      justify: "center",
                                      align: "center",
                                      "no-gutters": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "fill-height"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_PasswordPrompt, {
                                              activated: _ctx.activated,
                                              error: _ctx.error,
                                              "query-code": _ctx.queryCode,
                                              onClearError: _cache[2] || (_cache[2] = ($event: any) => (_ctx.error = '')),
                                              onGoToEmail: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeStep = _ctx.LoginSteps.EmailPrompt)),
                                              onCheckPassword: _cache[4] || (_cache[4] = ($event: any) => {_ctx.password = $event; _ctx.login()}),
                                              onGoToForgotPassword: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeStep = _ctx.LoginSteps.ForgotPassword)),
                                              onGoToResendRegistration: _cache[6] || (_cache[6] = ($event: any) => (_ctx.activeStep = _ctx.LoginSteps.ResendRegistration))
                                            }, null, 8, ["activated", "error", "query-code"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"]),
                                _createVNode(_component_v_stepper_window_item, {
                                  value: _ctx.LoginSteps.NewPasswordPrompt,
                                  "selected-class": "px-3"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      class: "fill-height",
                                      justify: "center",
                                      align: "center",
                                      "no-gutters": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "fill-height"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_PasswordPrompt, {
                                              error: _ctx.error,
                                              onClearError: _cache[7] || (_cache[7] = ($event: any) => (_ctx.error = '')),
                                              onGoToEmail: _cache[8] || (_cache[8] = ($event: any) => (_ctx.activeStep = _ctx.LoginSteps.EmailPrompt)),
                                              onCheckPassword: _cache[9] || (_cache[9] = ($event: any) => {_ctx.password = $event; _ctx.login()}),
                                              loading: _ctx.loading,
                                              activated: _ctx.activated,
                                              "is-new": _ctx.isNew
                                            }, null, 8, ["error", "loading", "activated", "is-new"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"]),
                                _createVNode(_component_v_stepper_window_item, {
                                  value: _ctx.LoginSteps.ForgotPassword,
                                  "selected-class": "px-3"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      class: "fill-height",
                                      justify: "center",
                                      align: "center",
                                      "no-gutters": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "fill-height"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ResendPrompt, {
                                              username: _ctx.username,
                                              onGoToEmail: _cache[10] || (_cache[10] = ($event: any) => (_ctx.activeStep = _ctx.LoginSteps.EmailPrompt))
                                            }, null, 8, ["username"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"]),
                                _createVNode(_component_v_stepper_window_item, {
                                  value: _ctx.LoginSteps.ResendRegistration,
                                  "selected-class": "px-3"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      class: "fill-height",
                                      justify: "center",
                                      align: "center",
                                      "no-gutters": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "fill-height"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ResendPrompt, {
                                              username: _ctx.username,
                                              activating: true,
                                              onGoToEmail: _cache[11] || (_cache[11] = ($event: any) => (_ctx.activeStep = _ctx.LoginSteps.EmailPrompt))
                                            }, null, 8, ["username"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"]),
                                _createVNode(_component_v_stepper_window_item, {
                                  value: _ctx.LoginSteps.Loading,
                                  class: "fill-height"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      class: "fill-height",
                                      justify: "center",
                                      align: "center",
                                      "no-gutters": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "text-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_2
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "auto" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_progress_circular, {
                                              indeterminate: "",
                                              color: "white"
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            }, 8, ["model-value"])
                          ]),
                          _: 1
                        }, 8, ["model-value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      flat: "",
      height: "64",
      color: "transparent"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          justify: "center",
          align: "end",
          class: "fill-height"
        }, {
          default: _withCtx(() => [
            (_ctx.helpUrl)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "auto",
                  class: "mx-4 bottom-link"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: _ctx.helpUrl,
                      target: "_blank",
                      class: "bottom-link"
                    }, "Help", 8, _hoisted_3)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.privacyUrl)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  cols: "auto",
                  class: "mx-4 bottom-link"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: _ctx.privacyUrl,
                      target: "_blank",
                      class: "bottom-link"
                    }, "Privacy Policy", 8, _hoisted_4)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.termsUrl)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 2,
                  cols: "auto",
                  class: "mx-4 bottom-link"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: _ctx.termsUrl,
                      target: "_blank",
                      class: "bottom-link"
                    }, "Terms & Conditions", 8, _hoisted_5)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 2))
}